import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
  CModalFooter,
  CModalBody,
  CModalHeader,
  CModal,
  CBadge,
} from '@coreui/react-pro'
import moment from 'moment'
import { Link } from 'react-router-dom'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'

const PricingPlanForLeagues = ({
  teamCount,
  activationInfo,
  gameInfo,
  paidPlanTypes,
  totalPaidAmount,
  handlePayNow,
  invoiceLink,
}) => {
  const [visibleModal, setVisibleModal] = useState(false)
  const [quoteData, setQuoteData] = useState({
    tier: '',
    duration: '',
    cost: 0,
    addScoreBlock: true,
  })
  const [activeTab, setActiveTab] = useState('tiered')
  const tableDataForLeagues = [
    { tier: '1-8 Teams', min_teams: 1, max_teams: 8, fee: '400' },
    { tier: '9-16 Teams', min_teams: 9, max_teams: 16, fee: '800' },
    { tier: '17+ Teams', min_teams: 17, max_teams: null, fee: '1200' },
  ]
  const handlePlanQuote = (amount, tier, duration, min_teams, max_teams) => {
    const additionalFee = 12
    const addScoreBlock = true
    const total = amount + (addScoreBlock ? additionalFee : 0)

    setQuoteData({
      tier,
      duration,
      cost: amount,
      addScoreBlock,
      additionalFee,
      total,
      min_teams,
      max_teams,
    })

    setVisibleModal(true)
  }

  const savePricingQuota = () => {
    CommonService.savePricingQuota(quoteData)
      .then((res) => {
        getPricingQuoteData()
        ToastComponent(res?.data?.message || 'Pricing quote saved successfully', 'success')
        setVisibleModal(false)
      })
      .catch((error) => {
        console.error('Error saving pricing quota:', error)
        const status = error?.status
        const message = error?.message

        if (status === 409 && message) {
          ToastComponent(message, 'error') // Show backend duplicate error
        } else {
          ToastComponent('Error saving pricing quota', 'error')
        }
      })
  }

  const [pricingQuoteRecords, setPricingQuoteRecords] = useState([])
  const [gamePlanTransactions, setGamePlanTransactions] = useState([])
  const getPricingQuoteData = React.useCallback(() => {
    CommonService.getPricingQuoteRecords()
      .then((res) => {
        if (res.status === 200) {
          setPricingQuoteRecords(res.data)
        }
      })
      .catch((e) => {
        console.log('Error fetching pricing quote:', e)
        ToastComponent('Something went wrong. Please try again.', 'error')
      })
  }, [])
  const getGamePricingData = React.useCallback(() => {
    CommonService.getGamePricingPlanRecords()
      .then((res) => {
        if (res.status === 200) {
          setGamePlanTransactions(res.data)
        }
      })
      .catch((e) => {
        console.log('Error fetching pricing quote:', e)
        ToastComponent('Something went wrong. Please try again.', 'error')
      })
  }, [])

  const getBadge = (status) => {
    switch (status) {
      case 1:
        return 'success'
      case 2:
        return 'danger'
      default:
        return 'warning'
    }
  }

  useEffect(() => {
    getPricingQuoteData()
    getGamePricingData()
  }, [getPricingQuoteData, getGamePricingData])
  return (
    <div>
      <CCard>
        <CCardHeader>
          <strong>Pricing Plan - Tournament Game (For Leagues)</strong>
        </CCardHeader>
        <CCardBody>
          {/* Tabs */}
          <CNav variant="tabs">
            <CNavItem>
              <CNavLink active={activeTab === 'tiered'} onClick={() => setActiveTab('tiered')}>
                Done-for-You
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                active={activeTab === 'unlimited'}
                onClick={() => setActiveTab('unlimited')}
              >
                Do-It-Yourself (Self Scoring)
              </CNavLink>
            </CNavItem>
          </CNav>

          <CTabContent>
            {/* Tiered Pricing Tab */}
            <CTabPane visible={activeTab === 'tiered'}>
              <p className="mt-3">
                Ideal for clubs that want a guided setup and want us to handle match score updates
              </p>
              <CTable bordered className="mt-4">
                <CTableHead color="warning">
                  <CTableRow>
                    <CTableHeaderCell>Team Tiers</CTableHeaderCell>
                    <CTableHeaderCell>1-3 Months</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {[
                    {
                      tier: '1–8 Teams',
                      three: '$600',
                      min_teams: 1,
                      max_teams: 8,
                    },
                    {
                      tier: '9–16 Teams',
                      three: '$1200',
                      min_teams: 9,
                      max_teams: 16,
                    },
                    {
                      tier: '17+ Teams',
                      three: '$1800',
                      min_teams: 17,
                      max_teams: null,
                    },
                  ].map((item, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{item.tier}</CTableDataCell>

                      <CTableDataCell>
                        <span
                          style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                          onClick={() =>
                            handlePlanQuote(
                              parseInt(item.three.replace('$', '')),
                              item.tier,
                              '1-3 Months',
                              item.min_teams,
                              item.max_teams,
                            )
                          }
                        >
                          {item.three}
                        </span>
                      </CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
              <ul>
                <li> We take care of setup, score updates, socials & support </li>
                <li> Unlimited Teams, Users, Players, Fixtures, and Analytics </li>
                <li> Fair use policy applies (30 fixtures to be scored per month)</li>
                <li> +$3/fixture applies for all fixtures above 30 fixtures</li>
                <li>
                  <strong> Add Extra Months:</strong> A$200 / month (optional)
                </li>
              </ul>
            </CTabPane>

            {/* Unlimited Access Tab */}
            <CTabPane visible={activeTab === 'unlimited'}>
              <p className="mt-3">
                Team Count:{' '}
                <strong>
                  <Link to="/teams">{teamCount}</Link>{' '}
                </strong>
              </p>
              <p>You enter scores, we power everything else</p>
              <p>Unlimited Teams, Users, Players, Fixtures, Duration, and Admin Access</p>
              <p>Ideal for internal club competitions</p>
              {/* {!activationInfo && gameInfo?.game_type !== 4 && ( */}
              <CTable bordered className="mt-3">
                <CTableHead>
                  <CTableRow color="warning">
                    <CTableHeaderCell>Team Tiers</CTableHeaderCell>
                    <CTableHeaderCell>Game Fee (in AUD)</CTableHeaderCell>
                    <CTableHeaderCell>Action</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {tableDataForLeagues.map((item, index) => {
                    const originalFee = parseInt(item.fee)
                    const planType = index + 1
                    const isPaid = paidPlanTypes.includes(planType)

                    const adjustedFee =
                      !isPaid && totalPaidAmount < originalFee
                        ? originalFee - totalPaidAmount
                        : originalFee <= totalPaidAmount
                        ? 0
                        : originalFee

                    return (
                      <CTableRow key={index}>
                        <CTableDataCell>{item.tier}</CTableDataCell>
                        <CTableDataCell>
                          AUD{' '}
                          {!isPaid && totalPaidAmount > 0 && originalFee > totalPaidAmount ? (
                            <span>
                              <del style={{ color: '#999' }}>{originalFee}</del>{' '}
                              <strong>{adjustedFee}</strong>
                            </span>
                          ) : (
                            originalFee
                          )}
                        </CTableDataCell>
                        <CTableDataCell>
                          {isPaid ? (
                            <span style={{ color: 'green', fontWeight: 'bold' }}>Paid</span>
                          ) : adjustedFee <= 0 ? (
                            <span style={{ color: 'green', fontWeight: 'bold' }}>Covered</span>
                          ) : (
                            <CButton
                              color="primary"
                              size="sm"
                              onClick={() => handlePayNow(adjustedFee, item.tier, planType)}
                            >
                              {totalPaidAmount > 0 ? 'Upgrade' : 'Pay Now'}
                            </CButton>
                          )}
                        </CTableDataCell>
                      </CTableRow>
                    )
                  })}
                </CTableBody>
              </CTable>
              {/* )} */}
              {!activationInfo && gameInfo?.game_type === 4 && (
                <div className="mt-3">
                  <stripe-pricing-table
                    pricing-table-id="prctbl_1Qk2wAItsmZf8AkXjYi6mFME"
                    publishable-key="pk_live_I2ZzJhqZwGTxEprRPJwLt4TE"
                  ></stripe-pricing-table>
                </div>
              )}
            </CTabPane>
          </CTabContent>

          {activeTab === 'tiered' && (
            <CCard className="mt-4">
              <CCardHeader>
                <strong>Quote Requests</strong>
              </CCardHeader>
              <CCardBody>
                <CTable>
                  <CTableHead>
                    <CTableRow>
                      <CTableHeaderCell scope="col">SN</CTableHeaderCell>
                      <CTableHeaderCell scope="col">Team Tiers</CTableHeaderCell>
                      <CTableHeaderCell scope="col">Amount</CTableHeaderCell>
                      <CTableHeaderCell scope="col">Status</CTableHeaderCell>
                      <CTableHeaderCell scope="col">Request on</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {pricingQuoteRecords.map((record, index) => (
                      <CTableRow key={index}>
                        <CTableHeaderCell scope="row">{index + 1}</CTableHeaderCell>
                        <CTableDataCell>{record.plan_name}</CTableDataCell>
                        <CTableDataCell>${record.total}</CTableDataCell>
                        <CTableDataCell>
                          <CBadge color={getBadge(record.status)}>
                            {record.status === 1
                              ? 'Approved'
                              : record.status === 2
                              ? 'Rejected'
                              : 'Pending'}
                          </CBadge>
                        </CTableDataCell>
                        <CTableDataCell>
                          {moment(record.created_at).format('D.MM.YYYY h:mm A')}
                        </CTableDataCell>
                      </CTableRow>
                    ))}
                  </CTableBody>
                </CTable>
              </CCardBody>
            </CCard>
          )}
        </CCardBody>
      </CCard>
      <CModal visible={visibleModal} onClose={() => setVisibleModal(false)}>
        <CModalHeader>
          <strong>Quote Summary</strong>
        </CModalHeader>
        <CModalBody>
          <p>
            <strong>Team Tier:</strong> {quoteData.tier}
          </p>
          <p>
            <strong>Plan Duration:</strong> {quoteData.duration}
          </p>

          {/* Checkbox for ScoreMail Block */}
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="scoremailCheckbox"
              checked={quoteData.addScoreBlock}
              onChange={(e) =>
                setQuoteData((prev) => ({
                  ...prev,
                  addScoreBlock: e.target.checked,
                  total: e.target.checked ? prev.cost + prev.additionalFee : prev.cost,
                }))
              }
            />
            <label className="form-check-label" htmlFor="scoremailCheckbox">
              Add ScoreMail Block (A$ {quoteData.additionalFee})
            </label>
          </div>

          <p>
            <strong>Cost:</strong> A$ {quoteData.cost}
            {quoteData.addScoreBlock && <> + A$ {quoteData.additionalFee}</>}
          </p>
          <p>
            <strong>Total:</strong> <strong>A$ {quoteData.total}</strong>
          </p>
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            onClick={() => {
              // Handle quote submission
              savePricingQuota(quoteData)
              setVisibleModal(false)
            }}
          >
            Submit Quote
          </CButton>
          <CButton color="secondary" onClick={() => setVisibleModal(false)}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  )
}

export default PricingPlanForLeagues
